require('../bootstrap');
require('../directives');
require('../filters');
require('./components');

import Slider from '../src/core/Slider';
import Scroller from '../src/core/Scroller';
import GoogleAnalytics from '../src/core/GoogleAnalytics';

import Media from '../src/mixins/Media';

(new Vue({
    el: '#app',
    mixins: [Media],
    data: {
        search: {
            opened: false
        },
        modal: {
            visible: false
        },
        slideshow: {
            active: false
        }
    },
    created() {
        this.$root.$on('slide-show-active', data => {
            this.slideshow.active = data.active;
        });
    },
    mounted() {
        window.addEventListener(
            'click',
            event => window.EventHandler.fire('body-clicked', event)
        );

        new GoogleAnalytics;
        new Slider;
        new Scroller;
    },
    methods: {
        backgroundImage(paths) {
            return {
                backgroundImage: 'url(\'' + paths[this.media] + '\')'
            }
        }
    }
}));



// WEBPACK FOOTER //
// ./resources/assets/js/front/app.js